import React, { useEffect } from 'react';
import { EventSource } from '@/shared/constants/event';
import { Layout } from '@/components/Common';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { logCommonView, logPageView } from '@/lib/service';
import HomepageV4 from '@/components/Home/HomepageV4';
import { STATIC_FILE_URL, WEBSITE_URL } from '@/shared/constants';
import Head from 'next/head';

const HOMEPAGE_TITLE = 'AI E-Commerce Platform for Brands - Sourcing, Fulfillment & Marketing | Pietra';
const HOMEPAGE_DESCRIPTION =
  'Pietra is the AI Commerce OS for e-commerce brands. Automate sourcing, fulfillment, marketing, and operations, all connected to your Shopify, TikTok, and Meta data.';
const HOMEPAGE_IMAGE = `${STATIC_FILE_URL}/8f83f11283ff5a8074adb986e14272f0.png`;

const Home = () => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Pietra',
    });
    logCommonView(EventSource.HOMEPAGE, 'INDEX');
  }, []);

  return (
    <>
      <Head>
        <title key="title">{HOMEPAGE_TITLE}</title>
        <meta key="description" name="description" content={HOMEPAGE_DESCRIPTION} />
        <meta key="og:url" property="og:url" content={WEBSITE_URL} />
        <meta key="og:title" property="og:title" content={HOMEPAGE_TITLE} />
        <meta key="og:description" property="og:description" content={HOMEPAGE_DESCRIPTION} />
        <meta key="og:image" property="og:image" content={HOMEPAGE_IMAGE} />
        <meta key="twitter:domain" property="twitter:domain" content="pietrastudio.com" />
        <meta key="twitter:url" property="twitter:url" content={WEBSITE_URL} />
        <meta key="twitter:title" name="twitter:title" content={HOMEPAGE_TITLE} />
        <meta key="twitter:description" name="twitter:description" content={HOMEPAGE_DESCRIPTION} />
        <meta key="twitter:image" name="twitter:image" content={HOMEPAGE_IMAGE} />
      </Head>
      <HomepageV4 />
    </>
  );
};

Home.getLayout = (page: React.ReactElement) => {
  return <Layout structured={SEO_META[SEO_META_PAGES.HOME]?.jsonld()}>{page}</Layout>;
};

export default Home;
